import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import ApiVersions from '../../types/enums/identityApiVersionEnums';
import {
  GluuBaseUrl,
  RequestId,
  LogoutPath,
  Inum,
  ChallengeId,
  ProfileId,
  Provider,
  WorkFlowId,
} from './identityApiConstants';

const headers = {
  'Content-Type': 'application/json',
};

export const generateOtpReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/otp`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const verifyOtpReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/otp/${RequestId}`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const resendOtpReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/otp/${RequestId}`,
  method: HTTPVerbs.PUT,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const logoutReqObj: RequestOptions = {
  retries: 0,
  url: `${GluuBaseUrl}/${LogoutPath}`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
};

export const checkUserExistanceReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/check-user`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const createPasswordReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${Inum}`,
  method: HTTPVerbs.PUT,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const forgotAmwayIdReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getJwtTokenReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const checkUserExistReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/check-user`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const updatePasswordReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}/password`,
  method: HTTPVerbs.PATCH,
  retries: 0,
};

export const generateTokenReqObj: RequestOptions = {
  url: `/comauthenticationas/v1/authenticate`,
  method: HTTPVerbs.POST,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  retries: 0,
};

export const sendOtpWithChallengeIdReqObj: RequestOptions = {
  url: `/comotpas/${ApiVersions.V1}/challenges/${ChallengeId}/otp`,
  method: HTTPVerbs.POST,
  body: JSON.stringify({}),
  retries: 0,
};

export const verifyOtpWithChallengeIdReqObj: RequestOptions = {
  url: `/comotpas/${ApiVersions.V1}/challenges/${ChallengeId}/otp`,
  method: HTTPVerbs.PATCH,
  retries: 0,
};
export const getChallenges: RequestOptions = {
  url: `/comotpas/${ApiVersions.V1}/challenges/${ChallengeId}/otp`,
  method: HTTPVerbs.GET,
  retries: 0,
};
export const generateChallengeIdForUpdatePasswordReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}/password/challenges`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getProfileIdReqObj: RequestOptions = {
  url: `/api/comcheckoutas/${ApiVersions.V1}/profiles`,
  method: HTTPVerbs.GET,
  body: JSON.stringify({}),
  retries: 0,
};

export const delinkSocialAccountReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}/external-identities/${Provider}`,
  method: HTTPVerbs.DELETE,
  retries: 0,
};

export const getUserByProfileIdReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const generateWorkflowReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/workflows`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const createPasswordWithWorkflowIdReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/workflows/${WorkFlowId}/submit`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getCurrentlyLoggedInUserDetailsReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const createChallengeIdForChangeAmwayIdReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}/username/challenges`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const updateUsernameChallengeIdForChangeAmwayIdReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/users/${ProfileId}/username`,
  method: HTTPVerbs.PATCH,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const switchAccountReqObj: RequestOptions = {
  url: `/comgluuoidc/${ApiVersions.V1}/switch-account`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const updateWorkflowReqForResetAmwayIdObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/workflows/${WorkFlowId}`,
  method: HTTPVerbs.PATCH,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const submitWorkflowReqObj: RequestOptions = {
  url: `/comidentityas/${ApiVersions.V1}/workflows/${WorkFlowId}/submit`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const createSocilaLinkChallengesObj: RequestOptions = {
  url: `/comauthenticationas/${ApiVersions.V1}/social-link/challenges`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const submitSocilaLinkChallengesObj: RequestOptions = {
  url: `/comauthenticationas/${ApiVersions.V1}/social-link`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const createSocialLinkLoggedInJansKey: RequestOptions = {
  url: `/comauthenticationas/${ApiVersions.V1}/social-link/jans-key`,
  method: HTTPVerbs.POST,
  headers: {
    'Content-Type': 'text/plain',
  },
  retries: 0,
};
